/**
 * @generated SignedSource<<1f7ac4363b6b5c5a278495b2ac09ec67>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime'
import { FragmentRefs } from 'relay-runtime'
export type PostListCard_posts$data = {
  readonly items: ReadonlyArray<{
    readonly h1: string
    readonly slug: string
    readonly image: {
      readonly url: string
      readonly alt: string | null
    } | null
  }>
  readonly ' $fragmentType': 'PostListCard_posts'
}
export type PostListCard_posts$key = {
  readonly ' $data'?: PostListCard_posts$data
  readonly ' $fragmentSpreads': FragmentRefs<'PostListCard_posts'>
}

const node: ReaderFragment = {
  argumentDefinitions: [],
  kind: 'Fragment',
  metadata: null,
  name: 'PostListCard_posts',
  selections: [
    {
      alias: null,
      args: null,
      concreteType: 'Post',
      kind: 'LinkedField',
      name: 'items',
      plural: true,
      selections: [
        {
          alias: null,
          args: null,
          kind: 'ScalarField',
          name: 'h1',
          storageKey: null
        },
        {
          alias: null,
          args: null,
          kind: 'ScalarField',
          name: 'slug',
          storageKey: null
        },
        {
          alias: null,
          args: null,
          concreteType: 'PostImage',
          kind: 'LinkedField',
          name: 'image',
          plural: false,
          selections: [
            {
              alias: null,
              args: null,
              kind: 'ScalarField',
              name: 'url',
              storageKey: null
            },
            {
              alias: null,
              args: null,
              kind: 'ScalarField',
              name: 'alt',
              storageKey: null
            }
          ],
          storageKey: null
        }
      ],
      storageKey: null
    }
  ],
  type: 'PostResult',
  abstractKey: null
}

;(node as any).hash = '59d25eaca28dbbd25ee257502fc3a375'

export default node
